import { HttpBackend, HttpClient, HttpHeaders } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from '@environment';
import { map, tap } from 'rxjs/operators';
import { BehaviorSubject, Subject } from 'rxjs';
import { DEFAULT_PAY_CONFIG, IPayConfig } from '@models/payment.model';
import { API_ENDTPOINTS } from '@models/api-endpoints';
import { EventsService } from '@services/events/events.service';
import { StorageService } from '@services/storage/storage.service';
import { UtilService } from '@services/util/util.service';
import { VariablesService } from '@services/variables/variables.service';

declare const Juspay;
declare const $;
@Injectable({
  providedIn: 'root'
})
export class PaymentService {

  public readonly http = inject(HttpClient);
  private readonly httpBackend = inject(HttpBackend);
  private readonly events = inject(EventsService);
  private readonly storage = inject(StorageService);
  private readonly util = inject(UtilService);
  private readonly vars = inject(VariablesService);

  private subsCountApiCalled = false;

  public APIURL = this.vars.domainData.apiUrl;

  public httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
    })
  };
  public httpOptionsHideError = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
    }),
    params: {
      showError: 'false'
    }
  };

  public juspayToken = new Subject<any>();

  private config: IPayConfig = DEFAULT_PAY_CONFIG;
  private updateConfig$ = new BehaviorSubject<Partial<IPayConfig>>(DEFAULT_PAY_CONFIG);
  readonly onConfigChange$ = this.updateConfig$.asObservable();

  selectedMode = '';
  selectedModeValue = '';
  selectedPaymentModeLabel = '';
  useSeletedMode = true;

  getConfig() {
    return { ...this.config };
  };

  setConfig(data: Partial<IPayConfig>, forceSet = false) {
    if (forceSet) {
      this.config = { ...this.config, ...data };
      this.updateConfig$.next(data);
      return;
    }

    const changed: Partial<IPayConfig> = {};
    for (const key in data) {
      const k: string = key as keyof IPayConfig;
      if (data[k] !== undefined && data[k] !== this.config[k]) {
        changed[k] = data[k]!;
        this.config[k] = data[k]!;
      }
    }
    if (Object.keys(changed).length > 0) {
      this.updateConfig$.next(changed);
    }
  }

  /**
   * Get the details for contribute form
   * @param campaignId
   */
  getContributeDetails(campaignId, qParam) {
    const url = this.APIURL + API_ENDTPOINTS.CONTRIBUTE_DETAILS_PAYMENT_FORM(campaignId);
    return this.http.get(url + qParam, this.httpOptions);
  }
  /**
   * Get the payment options available
   */
  getPaymentOptions(currency, params?) {
    let qPram = `?currency=${currency}`;
    if (params) {
      qPram = qPram.concat(`${params}`);
    }
    const url = this.APIURL + API_ENDTPOINTS.GET_PAYMENT_OPTIONS;
    return this.http.get(url + qPram, this.httpOptions);
  }
  /**
   * Send Amount to get the details
   * of the payments/order
   * @param data Data required to get oder details
   * @param campaignId Campaign ID
   */
  sendAmount(data, campaignId) {
    const url = this.APIURL + API_ENDTPOINTS.POST_AMOUNT_DETAILS(campaignId);
    return this.http.post(url, JSON.stringify(data), this.httpOptions);
  }
  /**
   * Place the order for the selected
   * by the user
   * @param data Data required to place order
   * @param campaignId Campaign ID
   */
  placeOrder(data, campaignId) {
    const url = this.APIURL + API_ENDTPOINTS.PLACE_ORDER(campaignId);
    return this.http.post(url, JSON.stringify(data), this.httpOptions);
  }
  /**Check the payment response after redirection from gateway
   * and get status of the order (successfull/failed)
   * @param data Response after payment
   */
  getOrderStatusAfterPayment(data) {
    const url = this.APIURL + API_ENDTPOINTS.GATEWAY_RESPONSE(data.oi);
    return this.http.post(url, JSON.stringify(data), this.httpOptions);
  }
  /**
   * Complete the order
   * @param data Data required to send order
   */
  sendOrder(data) {
    const url = this.APIURL + API_ENDTPOINTS.SEND_ORDER;
    return this.http.post(url, JSON.stringify(data), this.httpOptions);
  }
  /**Juspay token generate to coomplte
   * the card payment using juspay
   * @param data All the card details to generate token
   */
  juspayTokenGenerate(data) {
    const url = environment.juspay + 'card/tokenize?' + data;
    return this.http.jsonp(url, 'callback').pipe(
      map((res: any) => {
        return res.results.map(item => {
          console.log('asdasdasdasdasd', item);
          return item;
        });
      }),
      tap(res => console.log('fetched sellers')),
    );
  }
  /**Submit to the payment gateway */
  submitToPaymentGateway(res, gateway?, mode?) {
    const gatewayRespnse = res; // assuming that `res` holds the data return by JusPay API
    const url = gatewayRespnse.url;
    const method = gatewayRespnse.method;

    const frm = document.createElement('form');
    frm.setAttribute('method', method);
    frm.setAttribute('action', url);
    frm.setAttribute('id', 'payment_form');
    frm.setAttribute('class', 'juspay_inline_form'); // Class for juspay payment gateway

    if (gatewayRespnse.params) {
      const params = gatewayRespnse.params;
      for (const key of Object.keys(params)) {
        const value = params[key];
        const field = document.createElement('input');
        field.setAttribute('type', 'hidden');
        field.setAttribute('name', key);
        field.setAttribute('class', key);
        field.setAttribute('value', value);
        frm.appendChild(field);
      }
    }
    document.body.appendChild(frm);
    if (gateway === 'juspay' && mode === 'CARD') {
      console.log('Juspay submit setup');
      this.juspayFormSubmit();
      $('#payment_form').submit();
    }
    // form is now ready
    frm.submit();
  }

  /**Juspay form submit */
  juspayFormSubmit() {
    Juspay.Setup({
      payment_form: '#payment_form',
      success_handler: function (status) {
        // redirect to success page
        console.log('success');
        console.log('status', status);
      },
      error_handler: function (error_code, error_message, bank_error_code, bank_error_message, gateway_id) {
        // redirect to failure page
        console.log('failure');
        console.log('error_message', error_message);
        console.log('error_code', error_code);
        console.log('bank_error_code', bank_error_code);
        console.log('bank_error_message', bank_error_message);
        console.log('gateway_id', gateway_id);
      }
    });
  }

  /**
   * Get premium amount of the insurance
   * @param data object required
   */
  getInsurancePremium(data) {
    const url = this.APIURL + API_ENDTPOINTS.GET_INSURANCE_PREMIUM;
    return this.http.post(url, JSON.stringify(data), this.httpOptions);
  }
  /**
   * Add insurance
   * @param data object required
   */
  addInsurance(data) {
    const url = this.APIURL + API_ENDTPOINTS.ADD_INSURANCE;
    return this.http.post(url, JSON.stringify(data), this.httpOptions);
  }
  /**
   * AFter payment send the confirmation to db
   * to check if order is failed or succesfull
   * @param data object required
   */
  checkPaymentInsurance(data) {
    const url = this.APIURL + API_ENDTPOINTS.UPDATE_PAYMENT_INSURANCE;
    return this.http.post(url, JSON.stringify(data), this.httpOptions);
  }
  /**
   * Payment insurance
   * @param data object required
   * @param id insurance id
   */
  initiatePayment(data) {
    const url = this.APIURL + API_ENDTPOINTS.PAYMENT_INSURANCE;
    return this.http.post(url, JSON.stringify(data), this.httpOptions);
  }
  /**Get insurance info
   * @param id insurance Id
   */
  getInsuranceInfo(id: string) {
    const url = this.APIURL + API_ENDTPOINTS.GET_INSURANCE_INFO(id);
    return this.http.get(url, this.httpOptions);
  }
  /**
   * Check if the UPI id is valid or not
   * @param data VPA ID in object
   */
  vpaIdValidation(data) {
    const url = this.APIURL + API_ENDTPOINTS.VPA_VALIDATION;
    return this.http.post(url, JSON.stringify(data), this.httpOptions);
  }
  /**
   * Check the txn status of the vpa order
   * @param data Order Id in object
   */
  vpaTxnStatus(data) {
    const url = this.APIURL + API_ENDTPOINTS.VPA_TXN_STATUS;
    return this.http.post(url, JSON.stringify(data), this.httpOptions);
  }

  /**check if paytm apis are ready */
  isPaytmReady(callback) {
    if ((<any>window).JSBridge && callback) {
      callback();
    } else {
      document.addEventListener('JSBridgeReady', callback, false);
    }
  }
  /**Paytm auth login */
  paytmAuthFetch() {
    const clientId = environment.production ? 'merchant-ketto-prod' : 'merchant-ketto-uat';
    return new Promise((resolve, reject) => {
      try {
        this.isPaytmReady(() => {
          ((<any>window).JSBridge).call('paytmFetchAuthCode', { clientId: clientId }, (result) => {
            if (result.hasOwnProperty('error')) {
              reject(result.error);
            } else {
              const qparam = `?code=${result.data.authId}`;
              this.paytmLogin(qparam).subscribe((res) => resolve(res), (er) => reject(er));
            }
          });
        });
      } catch (error) {
        reject(false);
      }
    });
  }
  /**Paytm login wrapper */
  paytmLogin(qparam) {
    const url = this.APIURL + API_ENDTPOINTS.SOCIAL_LOGIN('paytm');
    return this.http.get(url + qparam, this.httpOptions);
  }

  /**Get subscriptions */
  getSubscriptions(query?) {
    const url = this.APIURL + API_ENDTPOINTS.GET_SUBSCRIPTIONS + query;
    return this.http.get(url, this.httpOptions);
  }

  /**Get User subscriptions */
  getUserSubscriptions(qparam?) {
    const url = this.APIURL + API_ENDTPOINTS.GET_LATEST_SUBS + (qparam || '');
    const options = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
      params: { showError: 'false' }
    };
    return this.http.get(url, options);
  }

  simplEligibilityCheck(data) {
    const options = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
      params: { showError: 'false' }
    };
    const url = this.APIURL + API_ENDTPOINTS.SIMPL_ELIGIBILITY_CHECK;
    return this.http.post(url, JSON.stringify(data), options);
  }

  sendCriticalIllness(entity_id, data) {
    const url = this.APIURL + API_ENDTPOINTS.ADD_CRITICAL_ILLNESS(entity_id);
    return this.http.put(url, JSON.stringify(data), this.httpOptions);
  }

  addCriticalIllness(entity_id, order_id, selectedIllness: { person: number, cover: string, illnessAmount: number }) {
    const payload = {
      info_1: JSON.stringify({
        person: selectedIllness?.person,
        cover: selectedIllness?.cover,
        add_on_price: selectedIllness?.illnessAmount
      }),
      info_2: order_id,
      info_type: 'critical_illness'
    };
    this.sendCriticalIllness(entity_id, payload).subscribe({
      next: (resp) => {
      }
    });
  }

  createStripeToken(data: { key: string }) {
    const httpWithoutInterceptor = new HttpClient(this.httpBackend);
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/x-www-form-urlencoded',
      })
    };

    const formBody = new URLSearchParams();
    for (const key in data) {
      if (data.hasOwnProperty(key)) {
        formBody.set(key, data[key]);
      }
    }

    return httpWithoutInterceptor.post('https://api.stripe.com/v1/tokens', formBody.toString(), httpOptions);
  }

  getSubsCount(cause?: string) {
    if (!this.subsCountApiCalled || cause) {
      this.subsCountApiCalled = true;
      let query = '';
      if (cause) { query = '?cause=' + cause; }
      this.getSubscriptions(query).subscribe((res: any) => {
        this.vars.countSubsCause = query.split('=')[1];
        this.vars.impactData = res.data.data;
        this.vars.subsCount.next(res.data.data);
      });
    }
  }

  redirectAfterPayment(params: any, status: string) {
    const cartData = this.storage.getFromSession('cartData');
    const typUrl = cartData?.showKCart ? '/new/kettokart/thankyou' : '/new/thankyou';

    const userdata = this.util.getUserData();

    if (params?.plan && params?.cover && params?.cover_amount && params?.person) {
      this.addCriticalIllness(userdata?.id, params?.oi, { person: +params?.person, cover: params?.cover + ' lakh', illnessAmount: +params?.cover_amount });
    }

    if (status === 'success') {
      if (params?.pledge_more) {
        const systemEvent = {
          eventName: 'pledge_more_confirmed',
          event_type: 'impact',
          info_1: 'position',
          info_2: `1,${userdata?.listsubscriptions[params?.sip_cause || 'medical']?.id},${params?.amt}`,
          info_3: 'impact'
        };
        this.events.sendSystemEvent(systemEvent).subscribe(_ => _);
      }

      const delete_param_list = ['amt', 'info_1', 'dnr', 'currency', 'payment_v', 'url', 'st'];

      let qparams;
      if (params?.payment_v === 'v2' && params?.k_params) {
        qparams = JSON.parse(params.k_params);
        if (!(params?.st === 'f' && params?.tip_amount && +params?.tip_amount !== 0)) {
          delete qparams?.last_success_campaign_id;
        }
        delete_param_list.forEach(val => {
          delete qparams[val];
        });
      } else {
        qparams = {
          id: params.id, oi: params.oi, or: params.or, social: params.social,
          payops: params.payops, utm_source: params.utm_source, eventPage: params.eventPage, dnr: params.dnr,
          tus: params.tus, cause: params.cause, lpm: params.lpm, offer: params.offer, sip_story: params.sip_story,
          ministoryquiz: params.ministoryquiz,
          person: params?.person,
          cover: params?.cover,
          cover_amount: params?.cover_amount,
          coupon_code: params?.coupon_code || null,
          sub_campaign_id: params?.sub_campaign_id || null,
          otd_sip: params?.otd_sip || null,
          frtip: params.frtip, coupon: params?.coupon, vendor: params?.vendor, plan: params?.plan, pledge_more: params?.pledge_more || null, ...this.vars.utmsObj
        };
      }
      qparams.entity_type = params?.entity_type || null;
      this.vars.router.navigate([typUrl], { queryParams: qparams });

      this.storage.deleteFromSession(params.oi);
      this.storage.delete('abandonedCartOtd');

      return;
    }

    if (status === 'failed') {
      this.failedRedirection(params, userdata);
    }
  }

  failedRedirection(params: any, userdata) {
    if (params.payment_v === 'v2' && params.k_params) {
      const qparam = {
        st: 'f',
        ...JSON.parse(params.k_params)
      };
      if (params.or === 'tp' || params.or === 'rfd') {
        qparam['last_success_order_id'] = userdata?.latestorder?.order_id || null;
        qparam['last_success_campaign_id'] = userdata?.latestorder?.campaign_id || null;
        qparam['pre_sip_cause'] = qparam?.sip_cause || null;
        qparam['sip_cause'] = null;
      }
      if (params.u_or) {
        qparam['or'] = params.u_or;
      }
      if (params.or !== 'tp') {
        qparam['ct'] = null;
      }
      if (params?.sip_wallet) {
        qparam['amt'] = +params.amt / (+params.wallet_tenure || 6);
      }

      this.vars.router.navigate([params.url], { queryParams: qparam });
      return;
    }

    switch (params.or) {
      case 'f':
        this.vars.router.navigate(['/fundraiser', params.ct], {
          queryParams: {
            st: 'f', oi: params.oi, id: params.id, social: params.social, payops: params.payops, min_donation: params?.min_donation || null,
            multi_patient_opted: params?.multi_patient_opted || null, otd_sip: params?.otd_sip || null,
            ...this.vars.utmsObj
          }
        });
        break;
      case 's':
        this.vars.router.navigate(['/stories', params.ct], {
          queryParams: {
            st: 'f', oi: params.oi, id: params.id, social: params.social, payops: params.payops, min_donation: params?.min_donation || null, mini_story: params?.mini_story || null,
            multi_patient_opted: params?.multi_patient_opted || null, otd_sip: params?.otd_sip || null,
            ...this.vars.utmsObj
          }
        });
        break;
      case 'tp':
        this.vars.router.navigate(['/new/thankyou', params.ct], {
          queryParams: {
            st: 'f', oi: params.oi, id: params.id, or: params.typOr, social: params.social, payops: params.payops, last_success_campaign_id: userdata?.latestorder?.campaign_id || null,
            last_success_order_id: userdata?.latestorder?.order_id || null, tip_amount: params?.tip_amount || null, frtip: params?.frtip,
            multi_patient_opted: params?.multi_patient_opted || null,
            entity_type: params?.entity_type || null, otd_sip: params?.otd_sip || null,
            ...this.vars.utmsObj
          }
        });
        break;
      case 'up':
        this.vars.router.navigate(['/new/campaign/campaign_update'], {
          queryParams: {
            st: 'f', oi: params.oi, id: params.id, or: 'up', fmd_id: params.fmd_id, update_id: params.update_id, type: 'onetime',
            action_date: params.action_date, donated_amount: params.donated_amount,
            donated_currency: params.donated_currency, is_donor: params.is_donor,
            multi_patient_opted: params?.multi_patient_opted || null, otd_sip: params?.otd_sip || null,
            ...this.vars.utmsObj
          }
        });
        break;
      case 'tann':
        this.vars.router.navigate(['/new/anniversary'], {
          queryParams: { st: 'f', ...this.vars.utmsObj }
        });
        break;
      case 'tip':
        this.vars.router.navigate(['/new/standalonetip'], {
          queryParams: { st: 'f', ...this.vars.utmsObj }
        });
        break;

      case 'ps':
        this.vars.router.navigate(['/new/payment'], {
          queryParams: {
            ct: params.ct,
            id: params.id,
            currency: params.pcurrency,
            st: 'f',
            type: 'full',
            vendor: params.vendor || null,
            plan: params.plan || null,
            person: params?.person || null,
            cover: params?.cover || null,
            pledge_more: params.pledge_more || null,
            multi_patient_opted: params?.multi_patient_opted || null,
            coupon_code: params?.coupon_code || null,
            otd_sip: params?.otd_sip || null,
            ...this.vars.utmsObj
          }
        });
        break;

      default:
        this.vars.router.navigate(['/payment-failed'], {
          queryParams: {
            oi: params.oi,
            id: params.id,
            reason: params.reason,
            ...this.vars.utmsObj
          }
        });
        break;

    }
  }



}
